import { useState, useCallback } from 'react';
import { isEmpty } from 'lodash';

/**
 * Custom hook for search state management in collection/category detail views
 * @returns {Object} Search state and handlers
 */
export const useCollectionSearch = () => {
  const [searchText, setSearchText] = useState('');
  const [activeSearchText, setActiveSearchText] = useState('');
  const [hasActiveSearch, setHasActiveSearch] = useState(false);

  const doSearch = useCallback(
    (e) => {
      e.preventDefault();
      if (!isEmpty(searchText)) {
        setHasActiveSearch(true);
        setActiveSearchText(searchText);
      }
    },
    [searchText]
  );

  const onClear = useCallback(() => {
    setSearchText('');
    setActiveSearchText('');
    setHasActiveSearch(false);
  }, []);

  return { searchText, setSearchText, activeSearchText, hasActiveSearch, doSearch, onClear };
};

export default useCollectionSearch;
